package com.neurobs.ccabserver.administrator.view

import com.neurobs.js.view.Container
import scalatags.JsDom.all._

class TestListView {
	import com.neurobs.js.dom.DOMViewElement._
	import TestListView._

	private val mainTable = table(`class` := TableClass).render

	def clear(): Unit = { mainTable.innerHTML = "" }

	def addRow(name: String, status: TestStatus.Value, pointerType: PointerType.Value)(onClick: () => Unit): Unit = {
		val row = tr(
			td(`class` := PointerUnselectedClass, pointerText(pointerType)),
			td(`class` := testStatusClass(status) + " " + UnselectedClass, name)
		).render
		row.onclick = (_) => onClick()
		mainTable.appendChild(row)
	}

	def setRowSelected(row: Int, selected: Boolean): Unit = {
		val otherClass = if (selected) UnselectedClass else SelectedClass
		val newClass = if (selected) SelectedClass else UnselectedClass

		val tableRow = mainTable.children(row)

		val nameCell = tableRow.children(1)
		if (nameCell.classList.contains(otherClass)) { nameCell.classList.remove(otherClass) }
		if (!nameCell.classList.contains(newClass)) { nameCell.classList.add(newClass) }

		val pointerClass = if (selected) PointerSelectedClass else PointerUnselectedClass
		tableRow.children(0).attributes.getNamedItem("class").value = pointerClass
	}

	val container: Container = mainTable
}

object TestListView {
	private val TableClass             = "test-list-table"
	private val SelectedClass          = "test-list-selected"
	private val UnselectedClass        = "test-list-unselected"
	private val PointerSelectedClass   = "test-list-pointer-selected"
	private val PointerUnselectedClass = "test-list-pointer-unselected"
	private val StatusPendingClass     = "test-list-status-pending"
	private val StatusInProgressClass  = "test-list-status-in-progress"
	private val StatusCompletedClass   = "test-list-status-completed"
	private val StatusErrorClass       = "test-list-status-error"

	object TestStatus extends Enumeration {
		val Pending, Success, Failure, Running = Value
	}

	def testStatusClass(status: TestStatus.Value): String = status match {
		case TestStatus.Pending => StatusPendingClass
		case TestStatus.Success => StatusCompletedClass
		case TestStatus.Failure => StatusErrorClass
		case TestStatus.Running => StatusInProgressClass
	}

	object PointerType extends Enumeration {
		val Current, Next, None = Value
	}

	def pointerText(t: PointerType.Value): String = t match {
		case PointerType.Current => "\u25BA"
		case PointerType.Next => "\u25BB"
		case PointerType.None => ""
	}
}